/**
 * bootstrap-daterangepicker only marks "Custom Range" active after both
 * dates are chosen. This keeps the option highlighted as soon as the user
 * clicks Custom Range or starts picking dates on the calendar.
 */
export const attachDateRangeCustomActiveFix = (_event, picker) => {
  if (!picker?.container || picker.__metubeCustomRangeFix) return;
  picker.__metubeCustomRangeFix = true;

  const customLabel = picker.locale?.customRangeLabel || "Custom Range";
  const $container = picker.container;

  const activateCustomRange = () => {
    $container.find(".ranges li").removeClass("active");
    $container
      .find('.ranges li[data-range-key="' + customLabel + '"]')
      .addClass("active");
    picker.chosenLabel = customLabel;
  };

  // Highlight immediately when Custom Range is clicked
  $container.on("click.metubeCustomRange", ".ranges li", function () {
    if (this.getAttribute("data-range-key") === customLabel) {
      setTimeout(activateCustomRange, 0);
    }
  });

  // Keep Custom Range active while selecting dates (endDate is null mid-pick)
  // and whenever the library chose Custom Range as the label
  const originalUpdateCalendars = picker.updateCalendars;
  picker.updateCalendars = function updateCalendarsWithCustomActive() {
    originalUpdateCalendars.call(this);

    const hasActive = $container.find(".ranges li.active").length > 0;
    const isCustom =
      this.chosenLabel === customLabel ||
      (!hasActive && this.endDate == null);

    if (isCustom) {
      activateCustomRange();
    }
  };
};
